var _rect, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardsPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FBB040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16821_19272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 10.8564H23V8.85645H13V10.8564H11C9.9 10.8564 9 11.7564 9 12.8564V13.8564C9 16.4064 10.92 18.4864 13.39 18.7964C14.02 20.2964 15.37 21.4264 17 21.7564V24.8564H13V26.8564H23V24.8564H19V21.7564C20.63 21.4264 21.98 20.2964 22.61 18.7964C25.08 18.4864 27 16.4064 27 13.8564V12.8564C27 11.7564 26.1 10.8564 25 10.8564ZM11 13.8564V12.8564H13V16.6764C11.84 16.2564 11 15.1564 11 13.8564ZM25 13.8564C25 15.1564 24.16 16.2564 23 16.6764V12.8564H25V13.8564Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.996 18.3335C21.4192 18.3335 19.3335 20.4247 19.3335 23.0002C19.3335 25.5757 21.4192 27.6668 23.996 27.6668C26.576 27.6668 28.6668 25.5766 28.6668 23.0002C28.6668 20.4237 26.576 18.3335 23.996 18.3335Z",
    fill: "white",
    stroke: "#FBB040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2085 20.9165H23.5835V23.4165L25.771 24.729L26.0835 24.2165L24.2085 23.104V20.9165Z",
    fill: "#FBB040"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16821_19272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 5.85645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardsPending);
export default __webpack_public_path__ + "static/media/AwardsPending.89f8648548019f3221abd849a627947c.svg";
export { ForwardRef as ReactComponent };